import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, moveVariableCategoryValue } from 'store/data/variables';

type HandlerInput = Parameters<typeof moveVariableCategoryValue>[0];

export function useMoveVariableCategoryValue(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.MOVE_VARIABLE_CATEGORY_VALUE);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(moveVariableCategoryValue(input));
	}

	return [{ loading, error }, handler];
}
